module.exports = __webpack_public_path__ + "img/Delivery.f9aa29a5.png";